import { Checkbox, Stack } from "@chakra-ui/react";
import React from "react";

const Checklist = ({ field, values, setFieldValue, isDisabled = false }) => {
  return (
    <Stack>
      {field.options.map((option) => (
        <>
          <Checkbox
            isDisabled={isDisabled}
            key={option}
            isChecked={values[`${field.id}`]?.includes(option)}
            onChange={(e) => {
              const valueArray = values[`${field.id}`] || [];
              if (e.target.checked) {
                setFieldValue(`${field.id}`, [...valueArray, option]);
              } else {
                setFieldValue(
                  `${field.id}`,
                  valueArray.filter((val) => val !== option)
                );
              }
            }}
          >
            {option}
          </Checkbox>
        </>
      ))}
    </Stack>
  );
};

export default Checklist;
